import { ga } from '../lib/router'
import { datum, geld, inclusief } from '../lib/opmaak'
import { zetLijst } from '../lib/staat'
import type { Expense } from '../lib/types'
import { STANDEN, standVan } from '../lib/werklijst'
import { HISTORIE, inDispuut } from '../lib/zicht.ts'

/* ===========================================================================
 *  Eén factuur in een lijst
 *
 *  Zoals Blue10: de relatie groot links, het bedrag rechts, daaronder het
 *  factuurnummer en de datum in grijs. Eén regel erbij die Blue10 niet heeft
 *  en het dashboard wel: in welke stand hij staat. Een lijst waarin je pas
 *  na het openen ziet of iets op jou wacht of op de AI-assistent, laat je
 *  elke factuur openen.
 * =========================================================================== */

/* De woorden van de historie in TW10 Online (b10/Detail.tsx, HISTORIE), nu uit zicht.ts: één lijst, ook voor In dispuut (23 okt 2026). */
export const GEDAAN: Record<string, string> = HISTORIE

export function standLabel(b: Expense): string {
  const s = standVan(b)
  /* Een nagekeken verkoopfactuur wacht op niemand meer (keten.ts,
     wachtOpIemand); "Wacht op akkoord" zou daar niet kloppen. */
  if (b.richting === 'verkoop' && s === 'akkoord') return 'Naar Exact'
  return STANDEN[s].label
}

export default function FactuurRij({ bon, lijst, extra }: { bon: Expense; lijst: Expense[]; extra?: string }) {
  const s = standVan(bon)
  return (
    <li>
      <button
        className="lijst-rij factuur-rij"
        onClick={() => {
          zetLijst(lijst.map((b) => b.id))
          ga(`/factuur/${encodeURIComponent(bon.id)}`)
        }}
      >
        <span className="fr-boven">
          <span className="fr-relatie">{bon.supplier.trim() || 'Onbekende relatie'}</span>
          <span className="fr-bedrag">{geld(inclusief(bon), bon.valuta)}</span>
        </span>
        <span className="fr-onder">
          <span className="fr-nummer">{bon.factuurnummer || bon.exactNummer || '—'}</span>
          <span className="fr-datum">{datum(bon.date)}</span>
        </span>
        <span className="fr-stand">
          {bon.richting === 'verkoop' && <span className="label label-verkoop">Verkoop</span>}
          {/* Het oranje merkje uit het overzicht van TW10 Online (0240). */}
          {inDispuut(bon) && <span className="label label-dispuut">In dispuut</span>}
          <span className={`label ${STANDEN[s].stuk ? 'label-stuk' : ''}`}>{extra ?? standLabel(bon)}</span>
        </span>
      </button>
    </li>
  )
}
